import { Card } from 'react-bootstrap';

// Mobile hero for the Discovery country-detail tree (General info / Cities /
// Companies / Visa & Stay / etc.). Mirrors companyDetail/CompanyDetailHero's
// shell (card-premium background, top-only radius) but keeps the country's
// existing content: eyebrow label, name, site URL, live cities count.
const CountryDetailHero = ({ countryName, url, cityCount, communityAction }) => {
    const trimmedUrl = (url || '').trim();

    return (
        <Card className="country-detail-hero">
            <div className="card-premium">
                <Card.Body>
                    <div className="country-detail-hero-header">
                        <h3>Country</h3>
                        {communityAction}
                    </div>
                    <div className="country-detail-hero-content">
                        <h1>{countryName || '—'}</h1>
                        <p className="country-detail-hero-metadata">
                            {trimmedUrl ? (
                                <a
                                    href={trimmedUrl.startsWith('http') ? trimmedUrl : `https://${trimmedUrl}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {trimmedUrl}
                                </a>
                            ) : '—'}
                            {cityCount > 0 && (
                                <>
                                    <span className="dot"></span>
                                    Live cities:&nbsp;<strong>{cityCount}</strong>
                                </>
                            )}
                        </p>
                    </div>
                </Card.Body>
            </div>
        </Card>
    );
};

export default CountryDetailHero;
